import { useRef, useState } from "react";
import { api, formatErr } from "../lib/api";
import { toast } from "sonner";
import { Upload, X, Loader2 } from "lucide-react";

/**
 * Reusable image upload widget.
 * Props: value (url), onChange(url|null), label, testid
 */
export default function ImageUpload({ value, onChange, label = "الصورة", testid = "upload" }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = () => fileRef.current?.click();

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (f.size > 15 * 1024 * 1024) return toast.error("حجم الصورة يجب ألا يتجاوز 15 ميجابايت");
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", f);
      const { data } = await api.post("/uploads", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("تم رفع الصورة");
    } catch (er) { toast.error(formatErr(er)); }
    finally { setBusy(false); }
  };

  const clear = () => onChange(null);

  const src = absoluteUrl(value);

  return (
    <div>
      <div className="text-xs font-bold text-gray-600 mb-1">{label}</div>
      <div className="flex items-center gap-3">
        <div className="w-20 h-20 rounded-2xl food-img overflow-hidden shrink-0 border border-orange-100">
          {src ? <img src={src} alt="" className="w-full h-full object-cover" /> :
            <div className="w-full h-full grid place-items-center text-2xl text-gray-400">🖼️</div>}
        </div>
        <div className="flex-1 flex flex-wrap gap-2">
          <button type="button" onClick={pick} disabled={busy}
            className="pill bg-white border border-orange-200 text-orange-700 px-3 py-2 text-xs font-bold inline-flex items-center gap-1 disabled:opacity-60"
            data-testid={`${testid}-btn`}>
            {busy ? <Loader2 size={14} className="animate-spin"/> : <Upload size={14}/>} {value ? "تغيير الصورة" : "رفع صورة"}
          </button>
          {value && (
            <button type="button" onClick={clear}
              className="pill bg-red-50 border border-red-100 text-red-600 px-3 py-2 text-xs font-bold inline-flex items-center gap-1"
              data-testid={`${testid}-clear`}>
              <X size={14}/> إزالة
            </button>
          )}
        </div>
      </div>
      <input ref={fileRef} type="file" accept=".jpg,.jpeg,.png,.webp,.heic,.heif" onChange={onFile} className="hidden" data-testid={`${testid}-input`} />
      <div className="text-[11px] text-gray-400 mt-1.5">JPG / PNG / WebP / HEIC — الحد الأقصى 15 ميجابايت</div>
    </div>
  );
}

export function absoluteUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}
